import i18n from "i18next";
import { SitePartTestConfigurationBomDataGrid } from "src/components/views/erp/configurator/configuratorTesting/sitePart/SitePartTestConfigurationBomDataGrid.tsx";
import { TestConfigurationResultViewCommonProps } from "../TestConfigurationResultViewCommonProps";
import { ConfiguratorLogView } from "../logViews/ConfiguratorLogView";
import { AavoMosaic } from "src/components/common/mosaic/AavoMosaic.tsx";
import { ConfiguratorLogApi } from "src/api/generated/erp/configurator/api/configuratorLogApi.ts";

export const SitePartTestConfigurationBomWithLogView = (
	props: TestConfigurationResultViewCommonProps,
) => {
	const { configuratorType, configurationSessionId } = props;
	return (
		<AavoMosaic
			viewId={"BA13C8371ED45761"}
			layout={{
				type: "row",
				first: {
					type: "panel",
					title: i18n.t("bom"),
					content: <SitePartTestConfigurationBomDataGrid {...props} />,
				},
				second: {
					type: "panel",
					title: i18n.t("bom_log"),
					content: (
						<ConfiguratorLogView
							fetchLogPathBase64={() =>
								ConfiguratorLogApi.getTestConfigurationPhaseResolvingLogBase64Path({
									phase: "BOM",
									sessionId: configurationSessionId,
									configuratorType: configuratorType,
								})
							}
						/>
					),
				},
			}}
		/>
	);
};
